<template>
  <naj-box
    :title="basicInfoLocal.secretaryInfo.title"
    no-gutters
  >
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <template v-else>
      <div v-if="!!secretaryDetails">
        <p class="section-header">
          {{ basicInfoLocal.secretaryInfo.secretaryBankruptcyInfo }}
        </p>
        <info-list
          v-if="secretaryDetails"
          :form-model="secretaryDetails"
          :headers="headers"
        ></info-list>
      </div>
      <template v-if="hasSecretaryApprovedDetails && !isPreventiveSettlement && !isAdministrativeLiquidation">
        <p class="section-header">
          {{ basicInfoLocal.secretaryInfo.secretaryApprovedInfo }}
        </p>
        <v-row class="pa-2">
          <v-col>
            <naj-data-table
              no-header
              disable-items-per-page
              :headers="headersApprovedDetails"
              :loading="loading"
              :items="secretaryApprovedDetails"
            ></naj-data-table>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="hasSecretaryApprovedDetails && isAdministrativeLiquidation">
        <p class="section-header">
          {{ basicInfoLocal.secretaryInfo.committeeBankruptcyInfo }}
        </p>
        <v-row class="px-5">
          <v-col
            cols="12"
            md="6"
            class="row py-2"
          >
            <v-col
              md="3"
              class="title py-0"
            >
              {{ basicInfoLocal.secretaryInfo.secretaryBankruptcyName }}
            </v-col>
            <v-col
              md="9"
              class="value py-0"
            >
              {{ ((secretaryApprovedDetails || [])[0] || {}).name }}
            </v-col>
          </v-col>
        </v-row>
        <v-row class="px-5">
          <v-col
            cols="12"
            md="6"
            class="row py-2"
          >
            <v-col
              md="3"
              class="title"
            >
              {{ basicInfoLocal.secretaryInfo.unifiedNumber }}
            </v-col>
            <v-col
              md="9"
              class="value"
            >
              {{ ((secretaryApprovedDetails || [])[0] || {}).unifiedNumber }}
            </v-col>
          </v-col>
        </v-row>
      </template>
      <naj-no-data
        :has-data="!!secretaryDetails || hasSecretaryApprovedDetails"
        :loading="loading"
      ></naj-no-data>
    </template>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';
import { procedureTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'SecretaryInfo',
  components: { InfoList },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      secretaryDetails: null,
      secretaryApprovedDetails: null,
      toHijriDate,
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile.basicInfo,
      headers: [
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestApplicant.fullName,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestApplicant.socialId,
        },
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestApplicant.socialIdType,
        },
        {
          key: 'identityTypeId',
          text: this.local.bankruptcy.requestApplicant.socialIdType,
          formatter: (val) => { return val == 1 ? this.local.bankruptcy.genders.male : (val == 2 ? this.local.bankruptcy.genders.female : '---'); },
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestApplicant.birthDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          key: 'nationalityName',
          text: this.local.bankruptcy.requestApplicant.nationality,
        },
        {
          key: 'secretaryLicenceNumber',
          text: this.local.bankruptcy.secretaryForm.licenceNumber,
        },
        {
          key: 'isApprovedFromCourt',
          text: this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.status,
          formatter: (val) => { return val == true ? this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.confirmed : this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.unConfirmed; },
        },
      ],
      headersApprovedDetails: [
        {
          value: 'name',
          text: this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.name,
        },
        {
          value: 'identityNumber',
          text: this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.identityNumber,
        },
        {
          value: 'isMain',
          text: this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.role,
          formatter: (val) => { return val == true ? this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.headSecretaryBankruptcy : this.local.bankruptcy.bankruptcyFile.basicInfo.secretaryInfo.secretaryBankruptcy; },
        },

      ],
      procedureTypeEnum,
    };
  },
  computed: {
    procedureType() {
      return this.requestInfo.openedProcedureId || this.requestInfo.procedureTypeId;
    },
    isPreventiveSettlement() {
      return this.requestInfo && this.procedureType == procedureTypeEnum.preventiveSettlement;
    },
    isAdministrativeLiquidation() {
      return this.requestInfo && this.procedureType == procedureTypeEnum.administrativeLiquidation;
    },
    hasSecretaryApprovedDetails() {
      return (this.secretaryApprovedDetails || []).length > 0;
    },

  },
  watch: {},
  mounted() {
    this.loading = true;
    this.getSecretaries(this.requestObjectKey)
      .then((res) => {
        this.secretaryDetails = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
    this.getMainRequestSecretariesApproved(this.requestObjectKey)
      .then((res) => {
        this.secretaryApprovedDetails = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: { ...mapActions(['getSecretaries', 'getMainRequestSecretariesApproved']) },
};

</script>

<style lang="scss" scoped>
.section-header {
  color: var(--app-dark-primary-color);
  font: normal normal bold 20px/31px Almarai;
  padding-top: 20px;
  padding-right: 25px;
}
.text-bold {
  font-weight: bold;
}
.title {
  color: #727272;
  font: normal normal normal 16px/17px Almarai;
  font-size: 16px !important;
}
.value {
  color: var(--app-dark-primary-color);
  font: normal normal bold 16px/25px Almarai;
  font-size: 16px !important;
}

::v-deep {
  .v-data-table {
    thead.v-data-table-header tr th {
      font-size: 14px;
      font-weight: bolder;
      color: var(--app-dark-primary-color) !important;
      padding: 20px;
    }

    tbody tr td {
      font-size: 12px;
      font-weight: bolder;
      color: var(--app-dark-primary-color);
      padding: 20px !important;
    }
  }
}
</style>
